export class MembershipTier {
  customerType: string = null;
  customerTypeName: string = null;
}
